import React from "react";
import { LandingHeader } from "@/components/landing/LandingHeader";
import { HeroSection } from "@/components/landing/HeroSection";
import { VideoSection } from "@/components/landing/VideoSection";
import { SeeItInAction } from "@/components/landing/SeeItInAction";
import {
    FrameworksStrip,
    FeaturesSection,
} from "@/components/landing/FeatureSections";
import {
    EnterpriseCapabilitiesSection,
    PricingSection,
    AiExcellenceSection,
    AimsSection,
} from "@/components/landing/CapabilitySections";
import { CaseStudiesSection } from "@/components/landing/CaseStudiesSection";
import { FounderSection } from "@/components/landing/FounderSection";
import { StickyMobileCta } from "@/components/landing/StickyMobileCta";
import { CustomerLogoStrip } from "@/components/landing/CustomerLogoStrip";
import { DemoRequestSection } from "@/components/landing/DemoRequestSection";
import {
    SecuritySection,
    FinalCtaSection,
    LandingFooter,
} from "@/components/landing/ClosingSections";

export default function Landing() {
    return (
        <div className="min-h-screen landing-page">
            <LandingHeader />
            <main id="main-content">
                <HeroSection />
                <SeeItInAction />
                <VideoSection />
                <FrameworksStrip />
                <CustomerLogoStrip />
                <FeaturesSection />
                <EnterpriseCapabilitiesSection />
                <PricingSection />
                <AiExcellenceSection />
                <AimsSection />
                <CaseStudiesSection />
                <FounderSection />
                <SecuritySection />
                <DemoRequestSection />
                <FinalCtaSection />
            </main>
            <LandingFooter />
            <StickyMobileCta />
        </div>
    );
}
